/* ============================================================
   Wyld Chics — offer strip above the header   (sections/wc-offer-strip.liquid)

   Liquid renders the strip for the page load. The header is not part of the
   theme's Section Rendering refresh, so on every cart event this re-reads
   /cart.js and redraws: empty cart -> marquee, items -> the cart bar's sentence
   and a fill line toward the next milestone. Same tiers, same message templates
   as snippets/wc-cart-rewards.liquid (they arrive as data-* attributes).

   Amounts, like the drawer: a shipping tier reads total_price (after every
   discount, which is what the free rate is judged on); a dollars-off tier reads
   original_total_price (before discounts, which is what its minimum is judged
   on). A free-shipping code is invisible to the cart totals: an applicable code
   that discounts nothing is a shipping code, and it lights the shipping tier.
   ============================================================ */
(function () {
  'use strict';

  function money(cents, fmt) {
    var f = fmt || (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var v = Math.max(0, cents) / 100;
    var whole = Math.abs(v - Math.round(v)) < 0.005;
    var n = whole ? String(Math.round(v)) : v.toFixed(2);   // money_without_trailing_zeros
    n = n.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return f.replace(/\{\{\s*amount(_no_decimals|_with_comma_separator)?\s*\}\}/, n);
  }
  function fill(template, map) {
    return String(template || '').replace(/\{(count|reward|have|code)\}/g, function (m, k) { return map[k] != null ? map[k] : m; });
  }

  /* "2 more pairs": one and other come from the locale (data-pairs-one / data-pairs-other, %n = the number) */
  function pairsText(el, rem) {
    var t = el.getAttribute(rem === 1 ? 'data-pairs-one' : 'data-pairs-other');
    if (t) return t.replace('%n', rem);
    return rem + ' more pair' + (rem === 1 ? '' : 's');
  }

  function draw(el, cart) {
    var tiers = [];
    try { tiers = JSON.parse(el.getAttribute('data-tiers') || '[]'); } catch (e) { tiers = []; }
    var bar = el.querySelector('[data-wc-strip-fill]');
    if (!cart || !cart.item_count || !tiers.length) { el.classList.add('is-empty'); setLive(el, ''); return; }
    el.classList.remove('is-empty');

    // a code that is applicable but shows up in no discount application can only be a shipping code
    var seen = {};
    (cart.cart_level_discount_applications || []).forEach(function (d) { if (d.type === 'discount_code') seen[String(d.title).toUpperCase()] = 1; });
    (cart.items || []).forEach(function (i) { (i.line_level_discount_allocations || []).forEach(function (a) { var d = a.discount_application || {}; if (d.type === 'discount_code') seen[String(d.title).toUpperCase()] = 1; }); });
    var shipCode = '';
    (cart.discount_codes || []).forEach(function (d) { if (d.applicable && !seen[String(d.code).toUpperCase()] && !shipCode) shipCode = d.code; });

    // pair tiers count one product type (the pack tiers count strip lashes), 2026-09-25
    var packType = el.getAttribute('data-pack-type') || 'Strip Lashes';
    var pairs = 0;
    (cart.items || []).forEach(function (i) { if (i.product_type === packType) pairs += i.quantity || 0; });

    var n = tiers.length, done = 0, next = -1, part = 0, rem = 0, nextLabel = '', haveLabel = '', nextUnit = 'amount';
    tiers.forEach(function (t, i) {
      var have = t.unit === 'items' ? pairs : (t.type === 'shipping' ? cart.total_price : cart.original_total_price);
      var hit = have >= t.at || (t.type === 'shipping' && !!shipCode);
      if (hit) { done += 1; haveLabel = t.label; }
      else if (next < 0) { next = i; rem = t.at - have; nextLabel = t.label; nextUnit = t.unit || 'amount'; part = t.at > 0 ? have / t.at : 0; }
    });
    var fmt = el.getAttribute('data-money-format');
    var msg;
    if (next < 0) msg = el.getAttribute('data-msg-max');
    else if (done > 0) msg = el.getAttribute('data-msg-unlocked');
    else msg = el.getAttribute('data-msg-next');
    var remText = nextUnit === 'items' ? pairsText(el, rem) : money(rem, fmt);
    var html = fill(msg, { count: '<b>' + remText + '</b>', reward: nextLabel, have: haveLabel });
    if (shipCode && done === 1 && n === 1) html = fill(el.getAttribute('data-msg-ship-code'), { code: shipCode.toUpperCase() });
    setLive(el, html);
    if (bar) bar.style.width = (next < 0 ? 100 : ((next + Math.min(1, part)) / n) * 100).toFixed(1) + '%';
  }

  /* the progress sentence is the marquee's first item while the cart has items; the marquee never stops */
  function setLive(el, html) {
    el.setAttribute('data-live-html', html || '');
    fitMarquee();
  }
  function baseOf(half) {
    if (half.hasAttribute('data-base')) return half.getAttribute('data-base');
    var base = Array.prototype.filter.call(half.children, function (c) { return !c.hasAttribute('data-wc-strip-live-item') && !c.classList.contains('wc-strip__sep--live'); })
      .map(function (c) { return c.outerHTML; }).join('');
    half.setAttribute('data-base', base);
    return base;
  }

  var seq = 0;
  function refresh() {
    var els = document.querySelectorAll('[data-wc-strip]');
    if (!els.length) return;
    var mine = ++seq;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { if (mine !== seq) return; els.forEach(function (el) { draw(el, cart); }); })
      .catch(function () {});
  }
  function measure() {
    var el = document.querySelector('[data-wc-strip]');
    if (el) document.documentElement.style.setProperty('--wc-strip-h', el.offsetHeight + 'px');
    fitMarquee();
  }
  /* the track slides one half; a half narrower than the strip leaves a gap on wide screens,
     so repeat the messages inside each half until it spans the strip (kept identical) */
  function fitMarquee() {
    document.querySelectorAll('[data-wc-strip]').forEach(function (el) {
      var halves = el.querySelectorAll('[data-wc-strip-half]');
      if (halves.length !== 2) return;
      var base = baseOf(halves[0]); baseOf(halves[1]);
      var liveHtml = el.getAttribute('data-live-html');
      if (liveHtml == null) { var li = halves[0].querySelector('[data-wc-strip-live-item]'); liveHtml = li ? li.innerHTML : ''; el.setAttribute('data-live-html', liveHtml); }
      var live = liveHtml ? '<span class="wc-strip__item wc-strip__item--live" data-wc-strip-live-item>' + liveHtml + '</span><span class="wc-strip__sep wc-strip__sep--live" aria-hidden="true">\u2726</span>' : '';
      var width = el.clientWidth, guard = 0;
      halves[0].innerHTML = live + base; halves[1].innerHTML = live + base;
      while (halves[0].scrollWidth < width && guard < 12) { halves[0].insertAdjacentHTML('beforeend', base); halves[1].insertAdjacentHTML('beforeend', base); guard += 1; }
      // the loop setting is "seconds for the messages once"; more repeats, proportionally more seconds, so the speed stays the same on every screen
      var track = el.querySelector('.wc-strip__track-mq');
      var cs = getComputedStyle(el);
      var base_s = parseFloat(cs.getPropertyValue(window.innerWidth <= 749 ? '--wc-strip-secs-m' : '--wc-strip-secs')) || 38;
      if (track) track.style.animationDuration = (base_s * (guard + 1 + (liveHtml ? 0.35 : 0))) + 's';
    });
  }

  ['shapes:cart:update', 'shapes:cart:cartqtychange', 'shapes:cart:afteradditem'].forEach(function (name) {
    window.addEventListener(name, function () { setTimeout(refresh, 40); });
  });
  document.addEventListener('theme:cart-drawer:closing', function () { setTimeout(refresh, 40); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) refresh(); });   // another tab changed the cart
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });                 // back/forward cache
  window.addEventListener('resize', measure);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', measure); else measure();
  (function () { var s0 = document.querySelector('[data-wc-strip]'); if (s0 && !s0.classList.contains('is-empty')) setTimeout(refresh, 300); })();   // Liquid cannot see a free-shipping code; one /cart.js read on load when the cart has items
  if (window.Shopify && window.Shopify.designMode) document.addEventListener('shopify:section:load', function () { measure(); refresh(); });
  // pause for the moving text (WCAG 2.2.2): the keyboard button, and a tap on the strip for phones
  function bindPause() {
    document.querySelectorAll('[data-wc-strip]').forEach(function (el) {
      if (el.hasAttribute('data-wc-pause-bound')) return;
      el.setAttribute('data-wc-pause-bound', '');
      var btn = el.querySelector('[data-wc-strip-pause]');
      function setPaused(on) {
        el.classList.toggle('is-paused', on);
        if (btn) { btn.setAttribute('aria-pressed', on ? 'true' : 'false'); btn.textContent = btn.getAttribute(on ? 'data-play' : 'data-pause'); }
      }
      if (btn) btn.addEventListener('click', function (e) { e.stopPropagation(); setPaused(!el.classList.contains('is-paused')); });
      var mq = el.querySelector('[data-wc-strip-mq]');
      if (mq) mq.addEventListener('click', function () { setPaused(!el.classList.contains('is-paused')); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindPause); else bindPause();
})();
